
import { DatePicker } from '@alifd/next';
import type { DatePickerProps } from '@alifd/next/types/date-picker'
import wrapper from './next-wrapper';

export type BLProFormDatePickerProps =DatePickerProps;

const BLProFormDatePicker = wrapper<BLProFormDatePickerProps>(DatePicker, 'BLProFormDatePicker');
const BLProFormDatePickerRangePicker = wrapper<BLProFormDatePickerProps>(DatePicker.RangePicker, 'BLProFormDatePickerRangePicker');

export {
    BLProFormDatePickerRangePicker
}

export default BLProFormDatePicker;
